/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Example_NoteInputs */

const ja_playdata_pricing_example_note = /** @type {(inputs: Playdata_Pricing_Example_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`※全日程27日間。10日間分は基本料金に含む`)
};

const en_playdata_pricing_example_note = /** @type {(inputs: Playdata_Pricing_Example_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`※ 27 days in total; 10 days are included in the base fee.`)
};

/**
* | output |
* | --- |
* | "※ 27 days in total; 10 days are included in the base fee." |
*
* @param {Playdata_Pricing_Example_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_example_note = /** @type {((inputs?: Playdata_Pricing_Example_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Example_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_example_note(inputs)
	return en_playdata_pricing_example_note(inputs)
});